import { firestore } from '@src/api/Firebase/Firebase';
import { collection, doc } from 'firebase/firestore';
import { Input } from '@api/Inputs/Input';
import { getRecipeCost, getRecipeCostSale, Recipe } from '@api/Recipes/Recipe';

// Una opción de modificador = una receta + cantidad + costo extra.
// extraCost 0 = variable normal (incluida en el precio) · >0 = extra cobrado al cliente.
export interface ModifierGroupOption {
    id: string; // estable una vez creada: las líneas de orden v2 la referencian (optionId)
    name: string; // "BBQ", "Boneless (4 pzas)" — SIN precio incrustado, la UI lo muestra
    recipeId: string; // qué receta consume
    quantityPerSelection: number; // recetas consumidas por cada selección
    extraCost: number;
    status: boolean;
}

export interface ModifierGroup {
    id?: string;
    name: string; // "Sabor de salsas", "Selección de piezas"
    options: ModifierGroupOption[];
}

export const buildRecipesById = (recipes: Recipe[]): Map<string, Recipe> => {
    const recipesById = new Map<string, Recipe>();
    recipes.forEach((recipe) => {
        if (recipe?.id) {
            recipesById.set(recipe.id, recipe);
        }
    });
    return recipesById;
};

// Costo de insumos que consume UNA selección de la opción, a costo de compra,
// costeado EN VIVO (receta → insumos vigentes). Recetas no encontradas suman $0.
export const getOptionConsumedCost = (
    option: Pick<ModifierGroupOption, 'recipeId' | 'quantityPerSelection'>,
    recipesById: Map<string, Recipe>,
    inputsById: Map<string, Input>
): number => {
    const recipe = option.recipeId ? recipesById.get(option.recipeId) : undefined;
    if (!recipe) {
        return 0;
    }
    return (Number(option.quantityPerSelection) || 0) * getRecipeCost(recipe.items, inputsById);
};

export const getOptionConsumedCostSale = (
    option: Pick<ModifierGroupOption, 'recipeId' | 'quantityPerSelection'>,
    recipesById: Map<string, Recipe>,
    inputsById: Map<string, Input>
): number => {
    const recipe = option.recipeId ? recipesById.get(option.recipeId) : undefined;
    if (!recipe) {
        return 0;
    }
    return (Number(option.quantityPerSelection) || 0) * getRecipeCostSale(recipe.items, inputsById);
};

export const getModifierGroupMissingRecipeIds = (
    options: ModifierGroupOption[],
    recipesById: Map<string, Recipe>
): string[] => {
    return (options || [])
        .map((option) => option.recipeId)
        .filter((recipeId) => !!recipeId && !recipesById.has(recipeId));
};

export const MODIFIER_GROUPS_COLLECTION = 'modifier-groups';

export const modifierGroupsRef = collection(firestore, MODIFIER_GROUPS_COLLECTION);

// Id estable para opciones nuevas (generador de auto-IDs de Firestore, sin escribir nada)
export const generateModifierOptionId = (): string => doc(modifierGroupsRef).id;
